import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import PageSkeleton from '../../components/PageSkeleton';
import { useApp } from '../../providers/UserProvider';
import { userCan, homePathOf } from '../../common/permissions';

// Enquanto o código da tela é baixado: menu e topo de verdade, conteúdo em
// esqueleto (components/PageSkeleton), no lugar da tela de carregamento
const withSkeleton = children => (
  <Suspense fallback={<PageSkeleton />}>{children}</Suspense>
);

/*
 * Guarda das telas logadas. Entra quem tem a permissão `ability`
 * (common/permissions.js) OU está na lista `roles` (o jeito antigo, ainda nas
 * telas não migradas). Sem nenhum dos dois, valem os papéis 1, 2 e 3, como
 * antes; com só `ability`, nenhuma lista de papéis vale. Quem não pode vai
 * para a tela inicial do próprio perfil (não para o Dashboard, que nem todo
 * perfil vê).
 */
function ProtectedRoute({
  children,
  roles = null,
  ability = null,
  anyRole = false,
}) {
  const { isAuthenticated } = useApp();
  const authenticatedUser = JSON.parse(
    localStorage.getItem('authenticatedUser'),
  );

  if (!isAuthenticated() || !authenticatedUser) {
    return <Navigate to="/" replace />;
  }

  // Primeiro acesso (senha gerada pelo sistema): só a tela Alterar senha, até
  // a pessoa criar a sua. A API também só aceita isso (Authenticate).
  if (authenticatedUser.must_change_password) {
    return window.location.pathname === '/alterar-senha' ? (
      withSkeleton(children)
    ) : (
      <Navigate to="/alterar-senha" replace />
    );
  }

  // Tela que todo perfil logado usa (Alterar senha, da barra lateral): quem
  // restringe o que cada um pode fazer é a API
  if (anyRole) {
    return withSkeleton(children);
  }

  // Sessão aberta antes das permissões (sem role.abilities, até o
  // UserProvider buscar de novo): valem as regras antigas, por papel
  const oldSession = !authenticatedUser.role?.abilities;
  const allowedRoles = roles || (ability && !oldSession ? [] : [1, 2, 3]);
  const byAbility = !!ability && userCan(authenticatedUser, ability);
  const byRole = allowedRoles.includes(authenticatedUser.role?.id);

  if (!byAbility && !byRole) {
    const home = homePathOf(authenticatedUser);
    // Sem acesso nem à própria tela inicial: volta ao login
    return (
      <Navigate to={home === window.location.pathname ? '/' : home} replace />
    );
  }

  return withSkeleton(children);
}

export default ProtectedRoute;
